<template>
    <div id="headerProjects">
        <nav :class="['navbar navbar-dark fixed-top bg-dark', { 'navbar-expand-md': menuDesktop }]" id="headerSecondary">
            <button
                class="navbar-toggler"
                type="button"
                id="activeMenuLateral"
                @click="ShowHiddenAside"
            >
                <span class="navbar-toggler-icon"></span>
            </button>
            <router-link :to="{ name: 'Projects' }" class="navbar-brand desktop">
                Projetcs
            </router-link>
            <div class="menu-responsive" v-if="!menuDesktop">
                <span :class="['badge badge-pill badge-light numID mobile', 'active']">
                    <span class="titulo-cont"> 5 Open</span>
                </span>
                <span :class="['badge badge-pill badge-light completed mobile']">
                    <span class="titulo-cont">Completed</span>
                </span>
                <button
                    class="navbar-toggler"
                    type="button"
                    id="activeMenuAvanzado"
                >
                    <i class="fas fa-ellipsis-v"></i>
                </button>
            </div>
            <div :class="['collapse navbar-collapse', activarMA ? 'in' : '']"
                class=""
                id="navbarCollapse"
            >
                <div class="row" style="width: 100%">
                    <div class="col-sm-2 col-xl-4">
                        <!-- <button class="btn btn-primary btn-sx">
                            <i class="fa fa-plus"></i>
                            Add New
                        </button> -->
                    </div>
                    <div class="col-sm-7 col-xl-4 text-center" style="padding-top: 2px">
                        <span
                            v-bind:class="[
                                'badge badge-pill badge-light numID desktop',
                                open ? 'active' : '',
                            ]"
                        >
                            <!-- <span class="badge badge-pill badge-danger num-cont"></span> -->
                            <span class="titulo-cont">5 Open</span>
                        </span>
                        <span :class="['badge badge-pill badge-light completed desktop']">
                            <span class="titulo-cont">Completed</span>
                        </span>
                    </div>
                    <div class="col-sm-3 col-xl-4 ">
                        <ul class="navbar-nav" style="justify-content: flex-end">
                            <li class="nav-item">
                                <router-link
                                    :to="{ name: 'Projects' }"
                                    class="nav-link"
                                >
                                    <i class="fas fa-th fa-lg"></i>
                                    <span class="mobile"> View Box</span>
                                </router-link>
                            </li>
                            <li class="nav-item dropdown" @mouseleave="closeSettingsDropdown">
                                <a href="#" class="nav-link dropdown-toggle" @click.prevent="toggleSettingsDropdown"
                                    :aria-expanded="settingsDropdownOpen.toString()">
                                    <i class="fas fa-cog fa-lg"></i>
                                </a>
                                <div class="dropdown-menu dropdown-menu-right" v-show="settingsDropdownOpen">
                                    <a class="dropdown-item" href="#">Option1</a>
                                    <a class="dropdown-item" href="#">Option2</a>
                                    <a class="dropdown-item" href="#">Option3</a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
// import Loader from "@/core/components/shared/Loader.vue";
export default {
    components: {
        // Loader,
    },
    name: "headerSecundary",
    data() {
        return {
            menuDesktop: true,
            isLoading: false,
            url: null,
            activar: false,
            lateral: true,
            open: true,
            activarMA: false,
            mainDropdownOpen: false,
            settingsDropdownOpen: false,
        };
    },
    created() {
    },
    methods: {
        toggleSettingsDropdown() {
            this.settingsDropdownOpen = !this.settingsDropdownOpen;
            if (this.mainDropdownOpen) this.mainDropdownOpen = false;
        },
        closeSettingsDropdown() {
            this.settingsDropdownOpen = false;
        },
        ShowHiddenAside() {
            this.lateral = !this.lateral;
            this.$store.commit("ModApps/projects/ActiveLateral", this.lateral);
        },
    },
    mounted() {
    },
    computed: {
        ...mapGetters("core/apps", ["get_appRolUser", "getAppIDactual"]),
    },
    watch: {
        $route(to, from) {
            this.url = to.name;
            console.log("lectura de route", to, this.$route.params)
        },
        isLoading: function () {
        },
    },
};
</script>
<style lang="scss" scoped>
span.badge.badge-pill.badge-info.check-done {
    width: 120px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
/* Opcional: puedes usar las clases de Bootstrap CSS para estilos */
.dropdown-menu {
	display: block;
	/* Bootstrap usa esto con JS */
	position: absolute;
}
.dropdown-menu[v-cloak] {
	display: none;
}
#headerProjects {
    position: relative;
}
#headerProjects nav.navbar.fixed-top {
    top: 40px;
    background-color: #343435 !important;
    padding: 2px 0px 2px 10px;
    width: 100%;
}
#activeMenuLateral {
    display: block;
    margin-right: 10px;
    border: 0;
    padding: 0;
}
span.badge.badge-pill.badge-light.active {
    border: 1px solid #ddd;
    color: #ddd;
}
span.badge.badge-pill.badge-light {
    background-color: transparent;
    border: 1px solid #989898;
    color: #989898;
    padding: .5em 2em;
    border-radius: 10px;
    cursor: pointer;
}
span.badge.badge-pill.badge-light {
    margin-left: 10px;
}
span.badge.badge-pill.badge-light:first-child {
    margin-left: 0px;
}
.titulo-cont {
    font-size: 16px;
}
.num-cont {
    font-size: 16px;
    padding: 0px 10px;
    margin-right: 10px;
    font-family: monospace;
}
.desktop {
    display: inline-block;
}
.mobile {
    display: none;
}
</style>
